<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel">
        <span *ngIf='display == 1' i18n="@@"> Contacts </span>
        <span *ngIf='display == 2' i18n="@@"> Clients </span>
    </h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div *ngIf='display == 1'> <!-- contact -->
    <app-contact-picklist [(referenceModel)]="model" (referenceModelChange)="close()"></app-contact-picklist>
</div>
<span *ngIf='display == 2'> <!-- client -->
    <app-client-picklist [(referenceModel)]="model" (referenceModelChange)="close()"></app-client-picklist>
</span>